(() => {
  const blocked = element => Boolean(element.closest('[hidden], dialog:not([open])'));
  function reveal(container, prepare = false) {
    container.querySelectorAll('[data-unico-src], [data-unico-href]').forEach(image => {
      if (prepare) {
        if (image.closest('[data-example-panel][hidden]')) return;
      } else if (blocked(image)) return;
      if (image.dataset.unicoSrcset) {
        image.srcset = image.dataset.unicoSrcset;
        delete image.dataset.unicoSrcset;
      }
      if (image.dataset.unicoSrc) {
        image.loading = prepare ? 'eager' : image.loading;
        image.fetchPriority = prepare ? 'low' : 'auto';
        image.src = image.dataset.unicoSrc;
        delete image.dataset.unicoSrc;
      }
      const href = image.dataset.unicoHref;
      if (href && image.getAttribute('href') !== href) image.setAttribute('href', href);
    });
  }
  window.UnicoImages = Object.freeze({reveal});
  let scheduled = false;
  const scan = () => {
    scheduled = false;
    reveal(document);
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(scan);
  };
  new MutationObserver(schedule).observe(document.documentElement, {
    subtree:true, childList:true, attributes:true, attributeFilter:['hidden','open','data-unico-href']
  });
  document.addEventListener('toggle', event => {
    if (!event.target.matches('details.unico-inline-size-guide[open]')) return;
    const template = event.target.querySelector('template[data-unico-guide]');
    if (template) template.replaceWith(template.content.cloneNode(true));
  }, true);
  scan();
})();
